export type AdminBadgeKey = "emergency" | "lifeSignal" | "workbox" | "sound" | "customerInquiry";

export type AdminNavigationItem = {
  icon: string;
  label: string;
  path: string;
  description: string;
  badgeKey?: AdminBadgeKey;
};

export type AdminNavigationGroup = {
  section: string;
  description: string;
  items: AdminNavigationItem[];
};

export const adminNavigationGroups: AdminNavigationGroup[] = [
  {
    section: "운영센터",
    description: "통합 업무함과 실시간 운영 현황",
    items: [
      {
        icon: "ri-inbox-2-line",
        label: "통합 업무함·대시보드",
        path: "/admin/dashboard",
        description: "긴급·생활신호·소리·문의 업무 큐",
        badgeKey: "workbox",
      },
      {
        icon: "ri-alarm-warning-line",
        label: "긴급 관제",
        path: "/admin/emergency",
        description: "SOS·낙상·위험 이벤트 처리",
        badgeKey: "emergency",
      },
    ],
  },
  {
    section: "사용자·기기",
    description: "Senior, Keeper, 연결 기기",
    items: [
      {
        icon: "ri-shield-user-line",
        label: "Senior·Keeper 사용자",
        path: "/admin/users",
        description: "앱 계정·상태·역할별 상세",
      },
      {
        icon: "ri-router-line",
        label: "기기 관리",
        path: "/admin/devices",
        description: "기기 상태·heartbeat·로그",
      },
      {
        icon: "ri-group-line",
        label: "가족 연결",
        path: "/admin/family-connections",
        description: "Keeper-Senior 연결 관계",
      },
    ],
  },
  {
    section: "케어 모니터링",
    description: "생활·건강·위치·일정·리포트",
    items: [
      {
        icon: "ri-heart-pulse-line",
        label: "생활신호 관제",
        path: "/admin/life-signal",
        description: "무응답·위험 신호·생활 타임라인",
        badgeKey: "lifeSignal",
      },
      {
        icon: "ri-map-pin-line",
        label: "위치 관제",
        path: "/admin/location",
        description: "최신 위치·홈 위치·이탈 상태",
      },
      {
        icon: "ri-calendar-check-line",
        label: "돌봄 일정",
        path: "/admin/daily-schedules",
        description: "수행 일정과 응답 상태",
      },
    ],
  },
  {
    section: "AI·콘텐츠",
    description: "현행 EAFR 원음과 모델 번들",
    items: [
      {
        icon: "ri-pulse-line",
        label: "EAFR 분석 이벤트",
        path: "/admin/eafr-sound-events",
        description: "최신 EAFR 실행·상황·생활신호 조회",
        badgeKey: "sound",
      },
      {
        icon: "ri-headphone-line",
        label: "원음 검수함",
        path: "/admin/sound-raw-audio-reviews",
        description: "EAFR 원음 재생·판정·검수 이력",
      },
      {
        icon: "ri-download-cloud-2-line",
        label: "EAFR 모델 번들",
        path: "/admin/sound-model-releases",
        description: "번들·구성요소·artifact·runtime 조회",
      },
    ],
  },
  {
    section: "과거 분석 도구",
    description: "v1·v2 모델 운영 이력",
    items: [
      {
        icon: "ri-sound-module-line",
        label: "과거 소리 v2 이벤트",
        path: "/admin/sound-analysis",
        description: "YAMNet 후보·메트릭·튜닝 이력",
      },
      {
        icon: "ri-database-2-line",
        label: "과거 소리 데이터셋",
        path: "/admin/sound-dataset-samples",
        description: "v1 수집 샘플·학습 검수 이력",
      },
      {
        icon: "ri-links-line",
        label: "과거 YAMNet 매핑",
        path: "/admin/sound-model-mapping-rules",
        description: "v1 라벨·그룹·위험도 매핑",
      },
    ],
  },
  {
    section: "멤버십·결제",
    description: "스토어 상품·구독·주문",
    items: [{ icon: "ri-bank-card-line", label: "멤버십·결제 조회", path: "/admin/memberships", description: "상품·구독·주문·알림 읽기 전용 조회" }],
  },
  {
    section: "고객지원·정책",
    description: "문의, 약관, 알림 정책",
    items: [
      {
        icon: "ri-question-answer-line",
        label: "1:1 문의",
        path: "/admin/customer-inquiries",
        description: "고객 문의와 답변 이력",
        badgeKey: "customerInquiry",
      },
      {
        icon: "ri-file-list-3-line",
        label: "약관 관리",
        path: "/admin/terms",
        description: "약관 버전과 게시 상태",
      },
    ],
  },
  {
    section: "시스템 관리",
    description: "권한, 감사, 운영 설정",
    items: [
      {
        icon: "ri-history-line",
        label: "감사로그",
        path: "/admin/audit-logs",
        description: "관리자 변경·삭제·해제 이력",
      },
      {
        icon: "ri-settings-3-line",
        label: "시스템 정보",
        path: "/admin/settings",
        description: "API 릴리즈·무결성·관리자 정보",
      },
    ],
  },
];

export const findNavigationItem = (pathname: string) => {
  for (const group of adminNavigationGroups) {
    const item = group.items.find((candidate) => pathname === candidate.path || pathname.startsWith(`${candidate.path}/`));
    if (item) {
      return { group, item };
    }
  }
  return null;
};
